import { ReactNode } from "react";
import { RouterProvider } from "react-router";
import { ClerkProvider } from "@clerk/clerk-react";
import { router } from "./routes";
import { AuthProvider as StudentAuthProvider } from "./context/studenthub/AuthContext";
import { UserPrefsProvider } from "./context/studenthub/UserPrefsContext";
import ErrorBoundary from "./components/ErrorBoundary";

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

// Only wrap with ClerkProvider when we have a valid publishable key.
// Without a key Clerk cannot initialise and all useAuth/useUser calls crash.
function WithClerk({ children }: { children: ReactNode }) {
  if (!CLERK_PUBLISHABLE_KEY) return <>{children}</>;
  return <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>{children}</ClerkProvider>;
}

export default function App() {
  return (
    <ErrorBoundary>
      <WithClerk>
        <StudentAuthProvider>
          <UserPrefsProvider>
            <RouterProvider router={router} unstable_useTransitions />
          </UserPrefsProvider>
        </StudentAuthProvider>
      </WithClerk>
    </ErrorBoundary>
  );
}
